<div class="modal fade" bsModal #sharedTemplatesModal="bs-modal" tabindex="-1" role="dialog"
  aria-labelledby="sharedTemplatesModalLabel" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="previewModalLabel">Component "{{templateComponent?.displayLabel}}" shared across
          {{sharedTemplates?.length == templatesTotalCount ? 'all' : sharedTemplates?.length}} templates</h4>
        <button id="sharedTemplatesModalHeaderClose" type="button" class="btn-close btn-close-white"
          data-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <table mat-table [dataSource]="sharedTemplates" class="mat-elevation-z8">
        
          <!-- Display Label Column -->
          <ng-container matColumnDef="template">
            <th mat-header-cell *matHeaderCellDef>Template</th>
            <td mat-cell *matCellDef="let element"> {{element.displayLabel}} </td>
          </ng-container>
        
          <!-- Product Line Column -->
          <ng-container matColumnDef="productLine">
            <th mat-header-cell *matHeaderCellDef>Product Line</th>
            <td mat-cell *matCellDef="let element"> {{element.productLine}} </td>
          </ng-container>
        
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <div class="modal-footer">
        <button id="sharedTemplatesModalFooterClose" type="button"
          class="col-md-3 col-md-offset-6 text-right btn btn-default btn-sm" data-dismiss="modal"
          (click)="closeModal()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>